import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import { useDrag } from 'react-dnd';
import { QuantityGetDto } from 'svila-common';
import moment from 'moment';

import DisplayLocation from '~/src/components/common/DisplayLocation';
import { DATE_FORMAT, ROLES } from '~/src/utils/constants';
import DisplayQuantities from '~/src/components/common/DisplayQuantities';
import DisplayDate from '~/src/components/common/DisplayDate';
import MyContext from '~/src/services/context';
import CheckboxInputComponent from '~/src/components/common/forms/CheckboxInput/CheckboxInputComponent';
import { Colors } from '~/src/scss/common/style';
import RolesDependent from '~/src/components/common/RolesDependent';

interface PropType {
  item: QuantityGetDto;
  rowId: string;
  handleClick?: any;
  isChecked?: any;
  title?: string;
}

export default function DragableInventory({ item, rowId, handleClick, isChecked, title }: PropType): JSX.Element {
  const context = useContext(MyContext);
  const canDrag = context?.user?.role !== 'WarehouseExternalUser';

  const [{ isDragging }, drag] = useDrag({
    type: rowId,
    item: item,
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  });

  return (
    <Wrapper ref={canDrag ? drag : undefined} style={{ opacity: isDragging ? 0 : 1 }}>
      <RolesDependent
        roles={[
          ROLES.ADMIN,
          ROLES.SUPER_ADMIN,
          ROLES.WAREHOUSE_ADMIN,
          ROLES.WAREHOUSE,
          ROLES.OFFICE,
          ROLES.SALES,
          ROLES.DATABASE_ADMIN,
          ROLES.SVILA_CLIENT_ADMIN,
          ROLES.SVILA_CLIENT
        ]}
      >
        {item.isSold ? (
          <p style={{ color: Colors.darkBrown }}>Sold</p>
        ) : (title === 'Ready' && item.isCustomerHasWarehouseOwner &&
          <CheckboxInputComponent name={item.tempId} checked={isChecked} onChange={handleClick} />
        )}
      </RolesDependent>
      <WrapperBox>
        <DisplayQuantities
          duQuantity={item.fullDuUnits}
          dpQuantity={item.singleDpUnits}
          cuQuantity={item.singleCuUnits}
        />
      </WrapperBox>
      <WrapperBox>
        <DisplayDate date={item.expirationDate} />
      </WrapperBox>
      <BackgroundBoxColor>{item.lot ?? ''}</BackgroundBoxColor>
      <WrapperBox>
        <DisplayLocation
          chamber={item.warehouseLocation.warehouseChamber.number}
          letter={item.warehouseLocation.letter}
          column={item.warehouseLocation.column}
          level={item.warehouseLocation.level}
        />
      </WrapperBox>
      <BackgroundBoxColor>
        {'PO: ' + (item.purchaseOrder?.orderNumber ?? '')}
      </BackgroundBoxColor>
      <BackgroundBoxColor>
        {'Warehouse: ' + (item.warehouse?.name ?? '')}
      </BackgroundBoxColor>
    </Wrapper>
  );
}

const WrapperBox = styled.div`
  margin: 2px;
`;

const BackgroundBoxColor = styled.div`
  margin: 2px;
  background-color:  #f4f4f4; /* Light gray background for better visibility */
  padding: 5px; /* Add padding for better spacing */
  border-radius: 5px; /* Optional: Add rounded corners */`;

const Wrapper = styled.div`
  position: relative;
  z-index: 10;
  flex-wrap: wrap;
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 10px;
  display: flex;
  align-items: center;
  padding: 5px;
  margin: 5px;
  span {
    font-size: 18px;
    color: #000;
  }
  color: #000;
`;
